import { render, staticRenderFns } from "./help-message-actions.vue?vue&type=template&id=61307ce5&scoped=true"
import script from "./help-message-actions.vue?vue&type=script&lang=js"
export * from "./help-message-actions.vue?vue&type=script&lang=js"
import style0 from "./help-message-actions.vue?vue&type=style&index=0&id=61307ce5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61307ce5",
  null
  
)

export default component.exports